import { Injectable } from '@angular/core';
import { User } from 'src/app/models/users.model';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map, first } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private user: User;
  user$: Observable<User>;

  constructor(
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth,
  ) {
    afAuth.user.subscribe((u) => {
      if (u) {
        this.updateUserObservable(u.uid);
        this.setIntercomUser();
      } else {
        this.user$ = null;
      }
    });
  }

  private async setIntercomUser() {
    const user = await this.getUser();
    (<any>window).Intercom('boot', {
      app_id: 'danvakjq',
      user_id: user.uid,
      name: user.name,
      email: user.email,
      created_at: user.registeredDate.toMillis() / 1000, // Unix Timestamp in seconds
    });
  }

  private updateUserObservable(userUid: string) {
    this.user$ = this.afs.doc<User>(`users/${userUid}`).valueChanges();
  }

  public getUser(): Promise<User> {
    return this.user$.pipe(first()).toPromise();
  }
}
